import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

const AZURE_CLIENT_ID = window.environment.REACT_APP_CLIENT_ID;
const AZURE_AUTHORITY = window.environment.REACT_APP_AUTHORITY;

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: AZURE_AUTHORITY,
    tenant: "deloitte.onmicrosoft.com",
    redirectUri: window.location.origin,
    audience: AZURE_CLIENT_ID,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    iframeHashTimeout: 10000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Coordinates and required scopes for your web API
export const apiConfig = {
  // resourceUri: "https://dauditptotracker2.deloitte.com/",
  // resourceScopes: ["https://dauditptotracker2.deloitte.com/Resource.GetStatus"]

  resourceUri: "https://dv1ptotrackerapi.aaps.deloitte.com/",
  resourceScopes: [
    "https://dv1ptotrackerapi.aaps.deloitte.com/Resource.GetStatus",
  ],
};

/**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
  scopes: ["User.Read"],
};

// Add here scopes for silent token request
export const silentRequest = {
  scopes: ["User.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const msalInstanceConfig = new PublicClientApplication(msalConfig);
